import { useCallback } from 'react';
import { useFocusEffect } from 'expo-router';

import { useAppState, useIsFocused } from '@sg/garnish';

import type { useOrderState } from '../useOrderState';

// ──────────────────────────────────────────────────────────────────────────

/**
 * Start/stop wanted times polling on bag focus.
 * Refetch wanted times on app focus if the bag has focus.
 */
export const useWantedTimePollingControl = (
  params: Pick<
    ReturnType<typeof useOrderState>,
    'startWantedTimesPolling' | 'stopWantedTimesPolling'
  >,
) => {
  const { startWantedTimesPolling, stopWantedTimesPolling } = params;
  const isFocused = useIsFocused();

  // Start/stop wanted times polling on bag focus.
  useFocusEffect(
    useCallback(() => {
      startWantedTimesPolling();

      return () => {
        stopWantedTimesPolling();
      };
    }, [startWantedTimesPolling, stopWantedTimesPolling]),
  );

  // Refetch wanted times on app focus if the bag has focus.
  useAppState({
    onVisible: useCallback(() => {
      if (!isFocused) return;

      startWantedTimesPolling();
    }, [startWantedTimesPolling, isFocused]),
  });
};
